import axios from "axios";
import { loginState } from "./StateApiCalls";
import { useNavigate } from "react-router-dom";

export const addNotes = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .post("https://mdos.calendarehr.com/api_main.php/addnotesform", input)
      .then((response) => {
        console.log("response:", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error Adding Notes:", error);
        reject(error.response.data);
      });
  });
};

export const addCurrentCondition = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        "https://mdos.calendarehr.com/api_main.php/addCurrentCondition",
        input
      )
      .then((response) => {
        console.log("response:", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error adding data:", error);
        reject(error.response.data);
      });
  });
};

export const addFamilyHistory = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .post("https://mdos.calendarehr.com/api_main.php/addFamilyHistory", input)
      .then((response) => {
        console.log("response:", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error Family History form:", error);
        reject(error.response.data);
      });
  });
};

export const addMedicalHistory1 = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        "https://mdos.calendarehr.com/api_main.php/addMedicalHistory1",
        input
      )
      .then((response) => {
        console.log("response:", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error signing up:", error);
        reject(error.response.data);
      });
  });
};

export const addMedicalHistory2 = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        "https://mdos.calendarehr.com/api_main.php/addMedicalHistory2",
        input
      )
      .then((response) => {
        console.log("response:", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error signing up:", error);
        reject(error.response.data);
      });
  });
};

export const addIntakeForm = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .post("https://mdos.calendarehr.com/api_main.php/addIntakeForm", input)
      .then((response) => {
        console.log("response:", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error signing up:", error);
        reject(error.response.data);
      });
  });
};

// .post("https://mdos.calendarehr.com/api_main.php/addinsuranceinfo", input)

export const addInsuranceInfo = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .post("https://mdos.calendarehr.com/api_main.php/addinsuranceinfo", input)
      .then((response) => {
        console.log("response:", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error submitting Insurance Data:", error);
        reject(error.response.data);
      });
  });
};

export const signup = (input) => {
  return new Promise((resolve, reject) => {
    axios
      .post("https://mdos.calendarehr.com/api_main.php/signup", input)
      .then((response) => {
        console.log("response:", response.data);
        resolve(response.data);
      })
      .catch((error) => {
        console.error("Error signing up:", error);
        reject(error.response.data);
      });
  });
};

export const login = (email, password, setUser) => {
  axios
    .get(`https://mdos.calendarehr.com/api_main.php/login`, {
      params: {
        email,
        password,
      },
    })
    .then((response) => {
      setUser(response.data);
      loginState(email, password);
      console.log(response.data);
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getUser = (email) => {
  return new Promise((resolve, reject) => {
    axios
      .get("https://mdos.calendarehr.com/api_main.php/searchUserByEmail/", {
        params: { email },
      })
      .then((response) => {
        //console.log("Get User: ", response);
        const { user } = response.data;

        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export const changePassword = (email, password) => {
  return new Promise((resolve, reject) => {
    axios
      .get("https://mdos.calendarehr.com/api_main.php/forgetpassword/", {
        params: {
          email: email,
          password: password,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};
